export type Profile = 'student' | 'mentor' | 'owner';

export const PROFILE_LEVEL: Record<Profile, number> = {
  student: 1,
  mentor: 2,
  owner: 3,
};

export const PROFILE_LABEL: Record<Profile, string> = {
  student: 'Aluno / Mentorado',
  mentor: 'Mentor',
  owner: 'Owner / Administrador',
};
